// extracted by mini-css-extract-plugin
export default {"margin-top":"gR5nql_WdThoWZo0GFtf","font-open-sans":"EZX2ZEFlt1rFfwdeA2rw"};